import { useMutation } from "@tanstack/react-query";

import { submitPaymentLinkData } from "../../services/paymentLinks";

export const useSubmitPaymentLinkData = (onSuccess?: () => void, onError?: () => void) => {
  return useMutation({
    mutationFn: async ({ linkId, data }: { linkId?: string; data: Record<string, string> }) => {
      return await submitPaymentLinkData({ linkId, data });
    },
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
    onError: () => {
      if (onError) onError();
    },
  });
};
